 import { LocationStrategy } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { FormValidation } from 'src/app/services/FormValidation';
import { ApiService } from "src/app/services/api.service";
import { CommonValues } from 'src/app/services/commonValues';
import { SearchData } from "src/app/services/searchData";
import { UtilService } from "src/app/services/util.service";
import { environment } from 'src/environments/environment';
import { CustomValidator } from '../../Helper/custom-validator';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.scss" ,  "../../../../assets/newassets/custom.css",  "../../../../assets/newassets/bootstrap/css/bootstrap.min.css"],
})
export class SignUpComponent extends FormValidation implements OnInit {

  @ViewChild('usernameInput') usernameInput!: ElementRef;

  ENVIRONMENT = environment
  signupForm: UntypedFormGroup;
  disableBtn = false;
  Authtokenservice: any;
  Authtoken: any;
  submitted = false;
  public FORMERROR = super.Form;
  userSubmit: boolean = false;
  userData: any;
  Msg = false;
  MsgFailed = false;
  fileToUpload: File = null;
  signupCheckEmail = false;
  signUpEmail = null;
  directoryProfileId: any;
  active;
  disabled = true;
  url: any;
  referalnew: any;
  emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  inviteeEmailId: any;
  constructor(
    private fb: UntypedFormBuilder,
    private API: ApiService,
    private router: Router,
    private cookieservice: CookieService,
    private route: ActivatedRoute,
    private util: UtilService,
    private searchData: SearchData,
    private CommonValues: CommonValues,
    private location: LocationStrategy,

  ) {
    super();

    this.googleLoginUrl = environment.googleRedirectUri;
    // history.pushState(null, null, window.location.href);
    // this.location.onPopState(() => {
    //   history.pushState(null, null, window.location.href);
    // });

    this.route.queryParams.subscribe((res) => {
      this.businessProfileId = res.businessProfileId;
      this.businessOrganizationDirectory = res.source;
      this.signUpEmail = res.emailId;
      this.referalnew = res.referalcode ?? res.referralCode ?? null;
    });

    var val: any = {}
    val.isLoggedOut = false;
    this.searchData.setCommonVariables(val);


   this.CommonValues.getRefreshpage().subscribe(ress=>{
      this.Msg=false;
      this.signupForm.reset();
   });

  }

  checkspace(event : any) : boolean{
    return  super.validSpace(event);
  }


  googleLoginUrl:string
  redirectToGoogle() {
    window.location.href = this.googleLoginUrl;
  }

  redirectTolinkedin() {
    window.location.href = this.googleLoginUrl;
  }



  ngOnInit() {
     this.signupForm = this.fb.group({
      firstName: [
        null,
        [Validators.required, Validators.pattern(this.FIRST_Name.pattern),
        CustomValidator.checkWhiteSpace(), CustomValidator.max(this.FIRST_Name.max)],
      ],
      lastName: [null, [Validators.required, Validators.pattern(this.LAST_NAME.pattern),
      CustomValidator.checkWhiteSpace(), CustomValidator.max(this.LAST_NAME.max)]],
      email: [
        null,
        [
          Validators.required,
          Validators.email, CustomValidator.max(this.EMAIL.max),
          Validators.pattern(this.EMAIL.pattern),
        ],
      ],
      Terms: [false, Validators.required],
      referralCode: [this.referalnew],

    });


    this.signupForm.valueChanges.subscribe((changedObj: any) => {
      this.disableBtn = this.signupForm.valid;
    });



    this.url = this.router.url;
    if (this.url.includes('auth/invite')) {
      this.route.queryParams.subscribe((res) => {
        this.inviteeEmailId = res.emailId;
        this.signupForm.patchValue({ email: this.inviteeEmailId })
        this.signupForm.controls['email'].disable();
      });
    } else {
      this.signupForm.controls['email'].enable();
      this.profilesignup();
    }

    this.route.queryParams.subscribe(params => {
      this.Msg = params['success'] === '1';
      if(this.Msg){
        this.signupForm.reset();
      }
    });
  }



  updateUserOnlineOrOffline(status: any) {
    let url = 'user/onlineoroffline';
    let user = {
      userId: localStorage.getItem('userId'),
      online: status.toUpperCase()
    };
    this.API.create(url, user).subscribe(res => {
    }, err => {
      this.util.stopLoader();

    });
  }

  onLogoutSuccess() {
    this.cookieservice.deleteAll();
    let allCookies = document.cookie.split(";");
    if (allCookies) {
      for (let i = 0; i < allCookies.length; i++) {
        document.cookie =
          allCookies[i] + "=;expires=" + new Date(0).toUTCString();
      }
    }
    localStorage.clear();

    var val: any = {}
    val.emailId = this.inviteeEmailId;
    this.router.navigate(["signUp"], { queryParams: val });
  }

  onLogout() {
    var val: any = {}
    val.isLoggedOut = true
    this.searchData.setCommonVariables(val);
    this.util.startLoader();
    this.API.onLogout().subscribe((res) => {
      if (res) {
        if (res.code === "00000") {
          this.util.stopLoader();
          // this.updateUserOnlineOrOffline('OFFLINE');
          this.onLogoutSuccess();
        } else {
          this.util.stopLoader();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 500);
    this.usernameInput.nativeElement.focus();
    
  }

  profilesignup() {
    this.route.queryParams.subscribe((res) => {
      this.directoryProfileId = res.profileId;
      if (this.signUpEmail != null) {
        this.signupForm.patchValue({
          email: this.signUpEmail
        })
      }
    });
  }

  get e() {
    return this.signupForm.controls;
  }


  @HostListener('document:keypress', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === "Enter") {
      if (this.signupForm.valid && this.signupForm.value.Terms) {
        this.signUp();
      }
    }
  }

  businessProfileId: any;
  businessOrganizationDirectory: any;
  isChecked: boolean = true
  npiNo: any;
  checkPolicy() {
    this.isChecked = $('#flexCheckDefault').is(":checked");

  }
  signUp() {
    this.signupForm.markAllAsTouched();
    this.userSubmit = true;
    this.signupCheckEmail = false;
    let data: any = {};
    data.firstName = this.signupForm.value.firstName;
    data.lastName = this.signupForm.value.lastName;
    data.email =  this.signupForm.getRawValue().email;
    data.directoryProfileId = this.directoryProfileId;
    data.profileId = this.businessProfileId;
    data.source = this.businessOrganizationDirectory;
    data.followEnabled = true;
    data.referralCode = this.referalnew;
    if (this.signupForm.valid && this.signupForm.value.Terms) {
      this.util.startLoader();
      this.API.create("user/signup", data).subscribe((res) => {
        this.util.stopLoader();
        if (res.code === "00000") {
          this.Msg = true;
          this.MsgFailed = false;
          // Push a real route change that adds a "success" marker
          this.router.navigate([], {
            queryParams: { success: '1' },
            queryParamsHandling: 'merge',
            replaceUrl: false
          });
        } else if (res.code === "99999") {
          this.Msg = false;
          this.MsgFailed = true;
        } else if (res.code === "ALREADY_REGISTER_USER") {
          this.MsgFailed = true
        } else if (res.code === "ALREADY_SIGNED_UP_CHECK_EMAIL") {
          this.signupCheckEmail = true;
        }
        this.util.stopLoader();
      }, err => {
        this.util.stopLoader();

      });
    }




  }

  Datareset() {
    this.signupForm.reset();
    // //// console.log('cancel button clicked')
  }

  resolved(captchaResponse: string) {
    // //// console.log(`Resolved captcha with response: ${captchaResponse}`);
  }




}
